<script setup lang="ts">
import type { IFeedDataClientDTO } from '~/shared/api/client/feed/feed.dto';
import FeedNewsItem from '~/widgets/feed-news-item/ui/FeedNewsItem.vue';
import { buildFeedRenderItems, FEED_BANNER_CONFIG_MAP } from './feedBanners';

const props = defineProps<{
  data?: IFeedDataClientDTO[];
  status?: string;
}>();

const renderedItems = computed(() => buildFeedRenderItems(props.data));
</script>

<template>
  <div
    v-if="status === 'success' && data && data.length > 0"
    :class="$style.root"
  >
    <template v-for="item in renderedItems" :key="item.key">
      <FeedNewsItem
        v-if="item.type === 'news'"
        v-bind="item.data.publisher_news[0]!"
        :class="$style.newsItem"
      />
      <Banner
        v-else
        :config="FEED_BANNER_CONFIG_MAP[item.bannerType]"
        :index="item.bannerIndex"
        align="left"
        :width="300"
        show-placeholder
        :placeholder-heights="{ xs: '300/600' }"
      />
    </template>

    <NuxtLink to="https://cre.ru/company/index" :class="$style.allNews">
      Все новости
    </NuxtLink>
  </div>
  <div
    v-else-if="
      status === 'error' || (status === 'success' && data && data.length === 0)
    "
    :class="$style.emptyState"
  >
    <p>Не удалось получить новости</p>
    <p>Попробуйте еще раз</p>
  </div>
  <div v-else-if="status === 'pending'">
    <Loader center small />
  </div>
</template>
<style lang="scss" module>
.newsItem {
  padding: var(--space-2-5x);
}

.emptyState {
  text-align: center;
  padding-top: 20px;
  p {
    margin: 10px 0;
  }
}

.allNews {
  display: flex;
  height: 40px;
  justify-content: center;
  align-items: center;
  @include text_button2;
  text-decoration: none;
  color: var(--color-black-1);
  border-top: 1px solid var(--color-gray-line);
}

@media (hover: hover) {
  .allNews {
    transition: all 0.2s;

    &:hover {
      opacity: 0.85;
    }
  }
}
</style>
